export class CookieService {

    public static SetGdprCookie(value: string) {
        this.createCookieWithExpiration('cookieConsent', value, 14400);
    }

    public static SetSocialMediaFollowersCookie(value: string) {
        this.createCookieWithExpiration('IATASocialMediaFollower', value, 525600);
    }

    public static SetCompareCoursesCookie(value: string) {
        this.createCookieWithExpiration('IATACompareCourses', value, 43200);
    }

    public static GetCompareCoursesCookie() {
        let compareCoursesCookie = this.getCookie('IATACompareCourses');
        if (typeof compareCoursesCookie == 'undefined') {
            return [];
        }

        // TrainingCourseComparisonPageController is encoding the json value, it needs to be done systematically.
        // Decoding a value without encoded strings will output the same thing.
        compareCoursesCookie = decodeURIComponent(compareCoursesCookie);

        return JSON.parse(compareCoursesCookie);
    }

    public static IsGdprAccepted() {
        const gdprCookieValue = this.getCookie('cookieConsent');
        return (gdprCookieValue === 'true');
    }

    // create a cookie with a value and an expiration date
    private static createCookieWithExpiration(name: string, value: string, minutesBeforeExpiration: number){
        var expirationValue = this.getFutureDate(minutesBeforeExpiration);
        this.createCookie(name,value,expirationValue);
    }

    private static createCookie(name:string, value:string, expiration:string | number) {
        document.cookie = name + "=" + value + ";expires=" + expiration + "; path=/";
    }

    // get the value of a cookie
    private static getCookie(nameCookie: string): string {
        const cookies = document.cookie.split("; ");

        const cookiesDictionnary = {};
        cookies.forEach((keyValue) => {
            const values = keyValue.split("=")
            cookiesDictionnary[values[0]] = values[1];
        });

        return cookiesDictionnary[nameCookie];
    }

    private static createSessionCookie(name: string, value: string){
        this.createCookie(name, value, 0);
    }

    private static getFutureDate (minutesInFuture : number): string{
        let  date = new Date();
        date.setTime(date.getTime() + (minutesInFuture * 60 * 1000));
        return date.toUTCString();
    }

    private static hasCookie(nameCookie : string): boolean{
        return Boolean(this.getCookie(nameCookie));
    }
}
